import { getProfiles, getProfile, patchProfile } from "api/profiles/calls";
import { createPrimitivePaginatedHook, createPrimitiveHook } from "hooks/createPrimitiveHook";
import { createAsyncUpdateConnector } from "utilities";

export const useProfiles = createPrimitivePaginatedHook(getProfiles);
export const useProfile = createPrimitiveHook(getProfile);
export const useUpdateProfile = createAsyncUpdateConnector(patchProfile);
